<template>
  <span :class="financialClass">{{highlightDifference && value > 0 ? '+' : ''}}{{value | formatCurrency}}</span>
</template>

<script>
export default {
  name: 'CurrencyValue',
  props: {
    highlightDifference: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 0
    }
  },
  computed: {
    financialClass() {
      if(this.highlightDifference) {
        return this.value < 0 ? 'financial-loss' : (this.value > 0 ? 'financial-profit' : '')
      }
      return ''
    }
  }
}
</script>